// Mock data for SalingUntung.com
export const mockData = {
  // Hero Section
  hero: {
    tagline: "Saling Untung – Driver Untung, Merchant Untung, Semua Untung",
    subtitle: "Platform digital yang menghubungkan driver pariwisata dengan berbagai merchant: toko oleh-oleh, tempat wisata, fashion, restoran, villa & hotel di seluruh Indonesia.",
    ctaDriver: "Daftar Sebagai Driver",
    ctaMerchant: "Daftar Sebagai Merchant",
    driverUrl: "https://mitra.salinguntung.com",
    merchantUrl: "https://merchant.salinguntung.com",
    heroImage: "https://firebasestorage.googleapis.com/v0/b/gps-tracker-3c2a1.appspot.com/o/sellio%2F1758302390147-undefined?alt=media&token=repo-seo-upgrade"
  },

  // Driver Benefits
  driverBenefits: {
    title: "Keuntungan untuk Driver",
    subtitle: "Dapatkan komisi otomatis setiap kali membawa tamu ke merchant partner",
    driverImage: "https://firebasestorage.googleapis.com/v0/b/gps-tracker-3c2a1.appspot.com/o/sellio%2F1758303361845-undefined?alt=media&token=repo-seo-upgrade",
    benefits: [
      {
        icon: "DollarSign",
        title: "Komisi Otomatis",
        description: "Dapatkan komisi langsung setiap bawa tamu belanja"
      },
      {
        icon: "Eye",
        title: "Saldo Transparan",
        description: "Pantau saldo dan riwayat komisi secara real-time"
      },
      {
        icon: "CreditCard",
        title: "Tarik Uang Mudah",
        description: "Cairkan komisi kapan saja ke rekening atau e-wallet"
      }
    ],
    steps: [
      {
        step: 1,
        title: "Scan QR Code",
        description: "Scan QR code merchant saat mengantar tamu"
      },
      {
        step: 2,
        title: "Merchant Input Transaksi",
        description: "Admin merchant input nominal belanja wisatawan"
      },
      {
        step: 3,
        title: "Komisi Langsung Cair",
        description: "Saldo bertambah otomatis, bisa ditarik langsung"
      }
    ],
    testimonials: [
      {
        name: "Andi Kurniawan",
        role: "Driver Tour Bandung",
        content: "Sejak pakai SalingUntung, penghasilan saya naik 40%. Komisinya transparan dan langsung masuk saldo.",
        rating: 5
      },
      {
        name: "Budi Santoso", 
        role: "Driver Wisata",
        content: "Enak banget, gak perlu ngemis-ngemis komisi lagi. Semua otomatis dan jelas.",
        rating: 5
      }
    ]
  },

  // Merchant Benefits
  merchantBenefits: {
    title: "Keuntungan untuk Merchant",
    subtitle: "Tingkatkan omzet bisnis Anda - mulai dari toko oleh-oleh, tempat wisata, fashion, restoran, hingga villa & hotel",
    merchantImage: "https://images.unsplash.com/photo-1708317033463-e1350cff1392?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxJbmRvbmVzaWFuJTIwc291dmVuaXIlMjBzaG9wfGVufDB8fHx8MTc1ODI2NzkwMXww&ixlib=rb-4.1.0&q=85",
    localMerchantImage: "https://firebasestorage.googleapis.com/v0/b/gps-tracker-3c2a1.appspot.com/o/sellio%2F1758303753643-undefined?alt=media&token=repo-seo-upgrade",
    benefits: [
      {
        icon: "Users",
        title: "Tambah Pengunjung",
        description: "Lebih banyak wisatawan datang ke bisnis Anda melalui driver partner"
      },
      {
        icon: "TrendingUp",
        title: "Omzet Naik",
        description: "Peningkatan revenue untuk semua jenis bisnis pariwisata"
      },
      {
        icon: "Settings",
        title: "Sistem Komisi Rapi",
        description: "Kelola komisi driver secara otomatis dan transparan"
      },
      {
        icon: "Smartphone",
        title: "Bisnis Tampil di Aplikasi",
        description: "Bisnis Anda terlihat di aplikasi driver dan wisatawan"
      }
    ],
    merchantTypes: [
      {
        icon: "ShoppingBag",
        title: "Merchant Oleh-oleh",
        description: "Kerajinan tangan, souvenir, dan produk khas daerah"
      },
      {
        icon: "MapPin",
        title: "Tempat Wisata",
        description: "Destinasi wisata, museum, dan atraksi lokal"
      },
      {
        icon: "Shirt",
        title: "Fashion & Retail",
        description: "Butik, merchant pakaian, dan aksesoris"
      },
      {
        icon: "UtensilsCrossed",
        title: "Restoran & Kuliner",
        description: "Rumah makan, cafe, dan tempat kuliner"
      },
      {
        icon: "Building",
        title: "Villa & Hotel",
        description: "Penginapan, villa, dan akomodasi wisata"
      },
      {
        icon: "Store",
        title: "Retail Lainnya",
        description: "Merchant dan bisnis retail lainnya"
      }
    ],
    partnerExample: {
      name: "Allamoda",
      description: "Toko fashion di Bandung yang sudah merasakan peningkatan omzet 60% sejak bergabung dengan SalingUntung",
      impact: "Peningkatan omzet 60%"
    }
  },

  // How It Works
  howItWorks: {
    title: "Cara Kerja SalingUntung",
    subtitle: "Sistem yang sederhana namun menguntungkan semua pihak",
    flowImage: "https://images.unsplash.com/photo-1739066598279-1297113f5c6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsb2NhbCUyMHNob3BzJTIwbWVyY2hhbnRzfGVufDB8fHx8MTc1ODI2Nzg3M3ww&ixlib=rb-4.1.0&q=85",
    steps: [
      {
        step: 1,
        title: "Registrasi",
        description: "Driver dan merchant mendaftar melalui platform masing-masing",
        icon: "UserPlus"
      },
      {
        step: 2,
        title: "Driver Membawa Tamu",
        description: "Driver mengantar wisatawan ke merchant yang sudah terdaftar",
        icon: "Car"
      },
      {
        step: 3,
        title: "Scan QR Code",
        description: "Driver scan QR code unik di merchant menggunakan aplikasi",
        icon: "QrCode"
      },
      {
        step: 4,
        title: "Input Transaksi",
        description: "Admin merchant input nominal belanja wisatawan ke sistem",
        icon: "Calculator"
      },
      {
        step: 5,
        title: "Komisi Otomatis",
        description: "Sistem hitung komisi driver dan fee platform secara otomatis",
        icon: "Zap"
      },
      {
        step: 6,
        title: "Withdraw",
        description: "Driver bisa tarik komisi kapan saja ke rekening atau e-wallet",
        icon: "Banknote"
      }
    ]
  },

  // About Us
  about: {
    title: "Tentang Kami",
    vision: "Membangun ekosistem wisata & belanja yang saling menguntungkan",
    description: "SalingUntung.com lahir dari filosofi kolaborasi, kepercayaan, dan saling mendukung. Kami percaya bahwa dengan teknologi yang tepat, semua pihak dalam ekosistem pariwisata - mulai dari driver, toko oleh-oleh, tempat wisata, restoran, fashion, hingga villa & hotel - bisa merasakan keuntungan yang adil dan transparan.",
    values: [
      {
        icon: "Handshake",
        title: "Kolaborasi",
        description: "Membangun kemitraan yang saling menguntungkan"
      },
      {
        icon: "Shield",
        title: "Kepercayaan", 
        description: "Transparansi dalam setiap transaksi dan komisi"
      },
      {
        icon: "Heart",
        title: "Saling Dukung",
        description: "Mendukung pertumbuhan bisnis semua mitra"
      }
    ]
  },

  // Contact
  contact: {
    title: "Hubungi Kami",
    subtitle: "Punya pertanyaan atau ingin bergabung? Kami siap membantu!",
    contactPerson: "Edvin Megantara",
    whatsappNumber: "+6285721347799",
    email: "maridigital.id@gmail.com",
    address: "KATAPANG SQUARE NO.A5, JL.TERUSAN KOPO BLOK A7, Pangauban, Katapang, Kab. Bandung, Jawa Barat 40921"
  },

  // Blog/News placeholder
  blog: {
    title: "Berita & Update",
    subtitle: "Informasi terbaru seputar SalingUntung dan industri pariwisata",
    posts: [
      {
        id: 1,
        title: "SalingUntung Resmi Diluncurkan di Bandung",
        excerpt: "Platform inovatif yang menghubungkan driver dan merchant kini hadir di Kota Kembang",
        date: "2024-01-15",
        category: "Berita"
      },
      {
        id: 2,
        title: "Tips Maksimalkan Komisi untuk Driver",
        excerpt: "Strategi efektif untuk meningkatkan penghasilan sebagai driver pariwisata",
        date: "2024-01-10", 
        category: "Tips"
      }
    ]
  }
};

export default mockData;

